import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconFonts: React.FC<IconProps> = ({ width = 24, height = 24, color = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
        >
            <g clip-path="url(#clip0_10693_2673)">
                <path
                    d="M11.4227 24H15.9744V22.3448C15.9744 22.1163 15.7891 21.931 15.5606 21.931H14.3192C13.6336 21.931 13.0778 21.3752 13.0778 20.6896V2.89655C13.0778 2.66803 13.2631 2.48273 13.4916 2.48273H18.4572C20.0519 2.48273 20.6631 4.12552 20.8596 4.68909C20.9172 4.85498 21.0738 4.96603 21.2495 4.96552H21.7675C21.996 4.96552 22.1813 4.78027 22.1813 4.5517V0.413813C22.1813 0.185297 21.9961 0 21.7675 0H1.07788C0.849313 0 0.664062 0.18525 0.664062 0.413813V4.55175C0.664062 4.78027 0.849313 4.96556 1.07788 4.96556H1.59594C1.77158 4.96608 1.92814 4.85503 1.98575 4.68914C2.1823 4.12556 2.79345 2.48278 4.38823 2.48278H9.35375C9.58227 2.48278 9.76756 2.66803 9.76756 2.89659V20.6897C9.76756 21.3753 9.21177 21.9311 8.52617 21.9311H7.28478C7.05627 21.9311 6.87097 22.1163 6.87097 22.3449V24H11.4227Z"
                    fill={color}
                />
                <path
                    d="M24.6637 19.8618C24.6637 19.8618 24.2499 23.9997 21.3534 23.9997C18.043 23.9997 17.6293 21.9308 17.6293 19.8618V11.9997C17.6293 11.7712 17.444 11.5859 17.2155 11.5859H15.5603C15.3318 11.5859 15.1465 11.4007 15.1465 11.1721V10.3172C15.1466 10.1057 15.3061 9.92834 15.5164 9.90588C16.4148 9.80946 18.7109 9.33776 19.6982 7.03418V9.10315C19.6982 9.56023 20.0687 9.93073 20.5258 9.93073H22.181C22.4095 9.93073 22.5948 10.116 22.5948 10.3445V11.1721C22.5948 11.4006 22.4095 11.5859 22.181 11.5859H20.112C19.8835 11.5859 19.6982 11.7712 19.6982 11.9997V19.8618C19.6982 22.3446 23.0086 23.1722 24.6637 19.8618Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10693_2673">
                    <rect width="24" height="24" fill="white" transform="translate(0.664062)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconFonts;
